import {axios as http} from "@/plugins/http"

export default class Api {
    static syncSlugByName(tagId, name) {
        return http.post("/api/v1/post/site/tags/sync-slug-by-name", {
            tag_id: tagId,
            name: name,
        });
    }
}
